const initialState = {
  catalogItems: [],
};

const catalogItems = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CATALOG_ITEMS':
      return {
        catalogItems: action.catalogItems,
      };
    default:
      return state;
  }
};

export default catalogItems;
